<template>
  <div
    class="dropdown"
    :class="{ 'dropdown--active': hover }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <InterfaceButtonsItem class="list" :item="item" :active="hover" />
    <div class="menu" v-if="item.childrens" v-show="hover">
      <InterfaceButtonsItem
        v-for="(children, index) in item.childrens"
        :key="index"
        :active="childIndex === index"
        :item="children"
        @mouseover.native="childIndex = index"
        @mouseleave.native="childIndex = null"
      >
        <div
          class="menu"
          v-if="children.childrens"
          v-show="hover && childIndex == index"
          :key="'menu' + index"
        >
          <InterfaceButtonsItem
            :active="childIndex2 == '0' + index"
            v-for="(child, index) in children.childrens"
            :key="index"
            :item="child"
            @mouseover.native="activeHoverChild(index)"
            @mouseleave.native="childIndex2 = null"
          >
            <div
              class="menu"
              v-if="child.childrens"
              v-show="hover && childIndex2 == '0' + index"
              :key="'menu' + index"
            >
              <InterfaceButtonsItem
                :active="childIndex3 == '00' + index"
                v-for="(child2, index) in child.childrens"
                :key="index"
                :item="child2"
                @mouseover.native="activeHoverChild2(index)"
                @mouseleave.native="childIndex3 = null"
              >
                <div
                  class="menu"
                  v-if="child2.childrens"
                  v-show="hover && childIndex3 == '00' + index"
                  :key="'menu' + index"
                >
                  <InterfaceButtonsItem
                    :active="childIndex4 == '000' + index"
                    v-for="(child3, index) in child2.childrens"
                    :key="index"
                    :item="child3"
                    @mouseover.native="activeHoverChild3(index)"
                    @mouseleave.native="childIndex4 = null"
                  >
                    <div
                      class="menu"
                      v-if="child3.childrens"
                      v-show="hover && childIndex4 == '000' + index"
                      :key="'menu' + index"
                    >
                      <InterfaceButtonsItem
                        :active="childIndex5 == '0000' + index"
                        v-for="(child4, index) in child3.childrens"
                        :key="index"
                        :item="child4"
                        @mouseover.native="activeHoverChild4(index)"
                        @mouseleave.native="childIndex5 = null"
                      />
                    </div>
                  </InterfaceButtonsItem>
                </div>
              </InterfaceButtonsItem>
            </div>
          </InterfaceButtonsItem>
        </div>
      </InterfaceButtonsItem>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InterfaceButtonsItem from 'components/setting/interface/InterfaceButtonsItem'
export default {
  name: 'InterfaceButtons',
  props: ['item'],
  components: {
    InterfaceButtonsItem,
  },
  data() {
    return {
      hover: false,
      childIndex: null,
      childIndex2: null,
      childIndex3: null,
      childIndex4: null,
      childIndex5: null,
    }
  },
  computed: {
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    activeHoverChild(index) {
      this.childIndex = index
      this.childIndex2 = '0' + index
      this.hover = true
    },
    activeHoverChild2(index) {
      this.childIndex = index
      this.childIndex2 = '0' + index
      this.childIndex3 = '00' + index
      this.hover = true
    },
    activeHoverChild3(index) {
      this.childIndex = index
      this.childIndex2 = '0' + index
      this.childIndex3 = '00' + index
      this.childIndex4 = '000' + index
      this.hover = true
    },
    activeHoverChild4(index) {
      this.childIndex = index
      this.childIndex2 = '0' + index
      this.childIndex3 = '00' + index
      this.childIndex4 = '000' + index
      this.childIndex5 = '0000' + index
      this.hover = true
    },
    inActiveHoverChild() {
      this.childIndex2 = null
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  .menu {
    width: max-content;
    position: absolute;
    top: 0;
    left: 100%;
    background-color: #ffffff;
    filter: drop-shadow(4px 4px 4px rgba(37, 120, 173, 0.2));
    transition: 0.3s;
  }
  &--active {
    background: #277faf;
    color: #ffffff;
    svg {
      filter: brightness(0) invert(1);
    }
  }
}
</style>
